import {
  Component,
  EventEmitter,
  Input,
  Output,
  OnInit,
  AfterViewInit,
} from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { EditorComponent } from '@tinymce/tinymce-angular';
import { MessageService } from 'primeng/api';
import { ApiService } from '../../services/api.service';
import { init } from '../editorconfig';

@Component({
  standalone:false,
  selector: 'app-project-closure',
  templateUrl: './project-closure.component.html',
  styleUrl: './project-closure.component.scss',
})
export class ProjectClosureComponent implements OnInit, AfterViewInit {
  @Input() stepDetails: any;
  @Input() schemeType: string;
  @Input() proposalName: string;
  @Input() urls: any={GPUrl:'/revenue/project/closure/'};
  @Output() routeConfig = new EventEmitter<any>();
  commentForm: FormGroup;
  rfpdata: any;
   init: EditorComponent['init'] = init;
  constructor(
    private fb: FormBuilder,
    private messageService: MessageService,
    private api: ApiService,
  ) {}

  ngOnInit(): void {
    this.commentForm = this.fb.group({
      final_offer: ['', Validators.required],
      delivery_date: [''],
      installation_date: [''],
    });
    this.commentForm.disable();
    this.getRfpDetails();
   
  }
  ngAfterViewInit() {
    setTimeout(() => {
      if(this.stepDetails.can_edit){
        this.commentForm.enable();
      }
    }, 3000);
  }

 



  getRfpDetails() {
    this.api.getAPI(`${this.urls.GPUrl}?proposal_step=${this.stepDetails.id}&proposal_step__proposal=${this.stepDetails.proposal}`)
      .subscribe((res: any) => {
        if (res) {
          this.rfpdata = res;
          this.commentForm.patchValue({
            final_offer: res?.justification || '',
            installation_date: res?.installation_date || '',
            delivery_date: res?.delivery_date || '',
          });
        }
      });
  }



  onSubmit(): void {
    const formData = new FormData();
    formData.append('proposal_step', this.stepDetails.id);
    formData.append('justification', this.commentForm.get('final_offer').value);
    
      formData.append('delivery_date', this.commentForm.get('delivery_date').value);
      formData.append('installation_date', this.commentForm.get('installation_date').value);
    
    const request$ = this.rfpdata?.id
      ? this.api.putAPI(`${this.urls.GPUrl}${this.rfpdata.id}/`, formData)
      : this.api.postAPI(this.urls.GPUrl, formData);
    request$.subscribe((res: any) => {
      this.getRfpDetails();
      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: res.message || (this.rfpdata?.id ? 'Offer updated successfully' : 'Offer uploaded successfully'),
      });
    });
  }


 
}
